/**
 * Storage helpers para el cliente activo.
 *
 * IMPORTANTE: usamos sessionStorage (no localStorage) para que cada tab
 * del browser pueda tener un cliente distinto seleccionado sin pisarse
 * entre sí (issue multi-tab, mayo 2026).
 *
 * Para compatibilidad con sesiones existentes, al leer migramos
 * automáticamente lo que haya en localStorage.selectedClient hacia
 * sessionStorage la primera vez que se accede (y limpiamos el localStorage).
 *
 * El fix correcto a futuro es pasar `clientId` por URL como query param
 * (ver docs/architecture/PLAN_URL_ROUTING.md). Esto es un quick-fix.
 */

const KEY = 'selectedClient';

let migrated = false;

const migrateIfNeeded = () => {
  if (migrated) return;
  migrated = true;
  try {
    if (typeof window === 'undefined') return;
    const fromSession = window.sessionStorage.getItem(KEY);
    const fromLocal = window.localStorage.getItem(KEY);
    if (!fromSession && fromLocal) {
      window.sessionStorage.setItem(KEY, fromLocal);
    }
    // Limpiamos el localStorage para que no quede legacy compartido entre tabs.
    if (fromLocal) {
      window.localStorage.removeItem(KEY);
    }
  } catch {
    // sessionStorage puede fallar en contextos privados / SSR — silencioso.
  }
};

export const getStoredSelectedClientRaw = (): string | null => {
  migrateIfNeeded();
  try {
    return window.sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
};

export const setStoredSelectedClientRaw = (value: string): void => {
  try {
    window.sessionStorage.setItem(KEY, value);
  } catch {
    // ignore
  }
};

export const removeStoredSelectedClient = (): void => {
  try {
    window.sessionStorage.removeItem(KEY);
    // También removemos del localStorage por si quedó algo del legacy.
    window.localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
};
